const ACTIONS = {
  'UPDATE_VOTES': 'UPDATE_VOTES',
};

export default ACTIONS;
